import axiosInstance from "../../../api/axiosInstance";

//Function method for post data from aws api lambda
export let postObject = async(method, user, formulary) => {
    let uri = process.env.REACT_APP_API  + "/"+ method;
    if (user != null && user != undefined && user != "") {
        uri = process.env.REACT_APP_API  + "/"+ method + "/" + user?.profile + "/" + user?.locale;
    }

    return new Promise((resolve, reject) => {   
        axiosInstance.post(uri, formulary).then(response=> {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    })
}